export const commandType = "SCHEDULE_MOVE_KAP";
export const label = "Scan area";
export const isAdminOnly = false;
export const isAdvanced = false;
export const organizations = [];
